module.exports = __webpack_public_path__ + "static/img/15.800f19f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/15.jpg
// module id = xiDr
// module chunks = 1